


import RedSection from "@/components/main/core/RedSection";
import GreySection from "@/components/main/core/GreySection";
import BoxPhoto from "@/components/main/core/BoxPhoto";
import CheckBox from "@/components/main/core/CheckBox";
import SingInForm from "@/components/main/forms/SingInForm";
import FormButton from "@/components/main/buttons/FormButton";

import newFeatured from "@/mixins/data"
export default {

  head() {
    const title = 'Log in to the iFindCheaters account';
    const canonical = 'https://ifindcheaters.com/auth/login/';

    return {
      title: title,
      link: [
        { rel: 'canonical', href: canonical }
      ],
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: 'Log in to the iFindCheaters account and find your cheating partner on all popular dating sites and apps all over the world.'
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
    }
  },

  name: "login",
  layout: 'clientLayout',
  mixins: [newFeatured],
  components: { SingInForm, BoxPhoto, FormButton, GreySection, RedSection, CheckBox },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
